import {Box,Grid,Paper,Alert,Breadcrumbs,Link,Typography,Card,CardContent,Tab,Tabs} from "@mui/material";
import FormDialog from "components/modal";
import BadgeIcon from "@mui/icons-material/Badge";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { tuyaUrl } from "services/API";
import { calculateHeaders } from "utilities/tuyaFunctions";
import SmartLockPasswordsTable from "components/Tables/smartLockPasswordsTable";
import SmartLockLogsTable from "components/Tables/smartLockLogsTable";
import SmartLockPasswordPopover from "components/PopOvers/SmartLockPasswordPopover";
import SmartLockTemporaryPasswordEditForm from "components/Forms/SmartLockTemporaryPasswordEditForm";
import TopSnack from "components/TopSnack";
import * as yup from 'yup';
import { UTCToDateTime } from "utilities/date";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const SmartLockActions = () => {
  const navigate = useNavigate();
  const smartDevice = useSelector((state)=> state.smartDevice);
  const tuyaToken = useSelector((state) => state.tuyaToken);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [open, setOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [activeUnit, setActiveUnit] = useState("")
  const [modal, setModal] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopper = Boolean(anchorEl);
  const popperId = openPopper ? "simple-popover" : undefined;
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [openSnack, setOpenSnack] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({})
  const [value, setValue] = useState(0);
  const [passwordName, setPasswordName] = useState("");

  const passwordSchema = yup.object().shape({
    passwordName: yup.string().required('This input is required')
  })

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack({ ...openSnack, open: false });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue===2) {
      fetchDeviceLogs();
    }else if (newValue===1){
      fetchPaswords(false);
    } else {
      fetchPaswords(true);
    }
  };


  const fetchDeviceLogs = ()=> {
    const {easy_sign, clientId, t} = calculateHeaders('business', '/v1.0/token?grant_type=1', null, 'GET' )
    
    const myHeaders = new Headers();
    myHeaders.append("client_id", clientId);
    myHeaders.append("sign", easy_sign);
    myHeaders.append("t", t);
    myHeaders.append("sign_method", "HMAC-SHA256");
    myHeaders.append("mode", "cors");
    myHeaders.append("nonce", "");
    myHeaders.append("mode", "cors");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${tuyaUrl}/v1.0/token?grant_type=1`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data)
        if (data.success){
          console.log(1)
          setIsLoadingData(false);
          setTableData(data.result);
        } else{
          setIsLoadingData(true)
        }
      })
      .catch((e) => console.error(e));

  }

  const fetchPaswords = (valid)=> {
    const {easy_sign, clientId, t} = calculateHeaders('business', `/v1.0/devices/${smartDevice.devId}/door-lock/temp-passwords?valid=${valid}`, tuyaToken.access_token, 'GET' )
    
    const myHeaders = new Headers();
    myHeaders.append("client_id", clientId);
    myHeaders.append("sign", easy_sign);
    myHeaders.append("t", t);
    myHeaders.append("sign_method", "HMAC-SHA256");
    myHeaders.append("mode", "cors");
    myHeaders.append("nonce", "");
		myHeaders.append("access_token", tuyaToken.access_token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${tuyaUrl}/v1.0/devices/${smartDevice.devId}/door-lock/temp-passwords?valid=${valid}`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success){
          setIsLoadingData(false);
          setTableData(data.result);
        } else{
          setIsLoadingData(true)
        }
      })
      .catch((e) => console.error(e));

  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSuccess(false);
      setIsFailed(false);
    }, 3000);
    fetchPaswords(true);
    return () => clearTimeout(timer);
  }, [isSuccess, isFailed]);

  const handleChangePasswordName = (e) => {
    const {value, name} = e.target;
    if (!toString(value).trim()) {
      setErrors((prev) => ({ ...prev, [name]: `This input is required` }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setPasswordName(value);
  }

  const handleSubmitEditPassword = async () => {
    try {
			await passwordSchema.validate({passwordName}, {abortEarly:false});
		} catch (error) {
			const newError = {}
			error.inner.forEach(err => {
				newError[err.path]=err.message
			})
			setErrors(newError)
			return
		}

    const {easy_sign, clientId, t} = calculateHeaders('business', `/v1.0/devices/${smartDevice.devId}/door-lock/temp-passwords/${activeUnit.id}/modify-password`, tuyaToken.access_token, 'PUT' )
    
    const myHeaders = new Headers();
    myHeaders.append("client_id", clientId);
    myHeaders.append("sign", easy_sign);
    myHeaders.append("t", t);
    myHeaders.append("sign_method", "HMAC-SHA256");
    myHeaders.append("mode", "cors");
    myHeaders.append("nonce", "");
		myHeaders.append("access_token", tuyaToken.access_token);

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${tuyaUrl}/v1.0/devices/${smartDevice.devId}/door-lock/temp-passwords/${activeUnit.id}/modify-password`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success){
          handleClose();
          setOpenSnack({ ...openSnack, open: true });
          setSeverity("success");
          setMessage("Password Delete Successful");
          fetchPaswords(true);
        } else{
          setOpenSnack({ ...openSnack, open: true });
          setSeverity("error");
          setMessage("Password Delete Failed");
        }
      })
      .catch((e) => console.error(e));
  };


  const handleSubmitDeletePassword = () => {
    const {easy_sign, clientId, t} = calculateHeaders('business', `/v1.0/devices/${smartDevice.devId}/door-lock/temp-passwords/${activeUnit.id}`, tuyaToken.access_token, 'DELETE' )
    
    const myHeaders = new Headers();
    myHeaders.append("client_id", clientId);
    myHeaders.append("sign", easy_sign);
    myHeaders.append("t", t);
    myHeaders.append("sign_method", "HMAC-SHA256");
    myHeaders.append("mode", "cors");
    myHeaders.append("nonce", "");
		myHeaders.append("access_token", tuyaToken.access_token);

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${tuyaUrl}/v1.0/devices/${smartDevice.devId}/door-lock/temp-passwords/${activeUnit.id}`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success){
          handleClose();
          setOpenSnack({ ...openSnack, open: true });
          setSeverity("success");
          setMessage("Password Delete Successful");
          fetchPaswords(true);
        } else{
          setOpenSnack({ ...openSnack, open: true });
          setSeverity("error");
          setMessage("Password Delete Failed");
        }
      })
      .catch((e) => console.error(e));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickPopOver = (event, row) => {
    setAnchorEl(event.currentTarget);
    setActiveUnit(row);
    setPasswordName(row.name);
  };

  const handleClosePopOver = () => {
    setAnchorEl(null);
  };

  const handleModalView = (modalView) => {
    setModal(modalView);
  };

  const handleClose = () => {
    setModal("");
  };

  return (
    <Box>
      {isSuccess ? (
          <Alert sx={{ m: "15px" }} variant="filled" severity="success">Operation was successful!</Alert>
      ) : isFailed ? (
          <Alert sx={{ m: "15px" }} variant="filled" severity="error">Operation was not successful!</Alert>
      ) : null}

      <Box sx={{padding: "10px",marginX: "5px", height:"95vh"}}>
          <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
            <Link underline="hover" sx={{ display: "flex", alignItems: "center" }} color="inherit" onClick={() => navigate("/propertyDetailsTab")}>
                <BadgeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Property
            </Link>
            <Typography sx={{ display: "flex", alignItems: "center" }} color="text.primary">
                <b>Smart Lock Details</b>
            </Typography>
          </Breadcrumbs>
          <Grid container spacing={1} className="alignHorizantal" sx={{ alignItems: "center" }}>
            <Grid item md={2.7} xs={12} sx={{ my: "15px", }}>
                <Paper sx={{ padding: "15px", margin: "10px" }} elevation={3}>
                  <Card sx={{ margin: "5px" }}>
                      <CardContent>
                          <Typography gutterBottom variant="h4" fontWeight="bold" component="div">DEVICE DETAILS</Typography>
                          <span><strong>Lock Name:</strong><Typography variant="body2" color="text.secondary">{smartDevice.productName}</Typography></span>
                          <span><strong>Device ID:</strong><Typography variant="body2" color="text.secondary">{smartDevice.devId}</Typography></span>
                          <span><strong>Last Activation:</strong><Typography variant="body2" color="text.secondary">{UTCToDateTime(smartDevice.activeTime)}</Typography></span>
                          <span><strong>Status:</strong><Typography fontWeight={"bold"} color={smartDevice.isOnline ? "green" :  "red"} variant="body2">{smartDevice.isOnline ? "Online" : "Offline"}</Typography></span>
                          
                      </CardContent>
                  </Card>
                  <hr />
                  <Tabs orientation="vertical" variant="scrollable" value={value} onChange={handleChange} aria-label="Vertical tabs example" sx={{ borderRight: 1, borderColor: "divider", marginY: "10px", }}>
                      <Tab label="Active Passwords" {...a11yProps(0)} />
                      <Tab label="Inactive Passwords" {...a11yProps(1)} />
                      <Tab label="Device Logs" {...a11yProps(2)} />
                  </Tabs>
                </Paper>
            </Grid>
            <Grid item md={9} xs={12} sx={{ my: "15px" }}>
                <TabPanel value={value} index={0}>
                    <Paper sx={{ padding: "15px", margin: "10px" }} elevation={3}>
                        {/* <FlexBetween> */}
                            <Typography variant="h5" fontWeight={"bold"} sx={{ marginBottom:"5px" }}>ACTIVE PASSWORDS</Typography>
                            <SmartLockPasswordsTable rows={tableData} isLoadingData={isLoadingData} handleClickPopOver={handleClickPopOver} id={popperId} hasActions={true}/>
                        {/* </FlexBetween> */}
                    </Paper>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Paper sx={{ padding: "15px", margin: "10px" }} elevation={3}>
                        {/* <FlexBetween> */}
                            <Typography variant="h5" fontWeight={"bold"} sx={{ marginBottom:"5px" }}>INACTIVE PASSWORDS</Typography>
                            <SmartLockPasswordsTable rows={tableData} isLoadingData={isLoadingData} handleClickPopOver={handleClickPopOver} id={popperId}/>
                        {/* </FlexBetween> */}
                    </Paper>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Paper sx={{ padding: "15px", margin: "10px" }} elevation={3}>
                        {/* <FlexBetween> */}
                            <Typography variant="h5" fontWeight={"bold"}>DEVICE LOGS</Typography>
                            <SmartLockLogsTable rows={tableData} isLoadingData={isLoadingData} handleClickPopOver={handleClickPopOver} id={popperId}/>
                        {/* </FlexBetween> */}
                    </Paper>
                </TabPanel>
            </Grid>
          </Grid>
      </Box>
      <SmartLockPasswordPopover
        popperId={popperId}
        openPopper={openPopper}
        anchorEl={anchorEl}
        handleClosePopOver={handleClosePopOver}
        handleClickOpen={handleClickOpen}
        handleModalView={handleModalView}
      />
      {modal === 'edit' ? (
        <FormDialog
          title = "Edit Password"
          enableActions={true}
          open={open}
          content = {
            <SmartLockTemporaryPasswordEditForm
              passwordName={passwordName}
              handleChangePasswordName={handleChangePasswordName}
              errors={errors}
            />
          }
          handleSubmit={handleSubmitEditPassword}
          handleClose={handleClose}
          buttonText="Edit Password"
        />
      ): modal === 'delete' ? (
        <FormDialog
          title="Delete Password"
          enableActions={true}
          open={open}
          content={
            <Box>
              <Typography color="red">Are you sure you want to delete this password?</Typography>
            </Box>
          }
          handleSubmit={handleSubmitDeletePassword}
          handleClose={handleClose}
          buttonText="Delete Password"
        />
      ) : null}
      <TopSnack
        vertical={openSnack.vertical}
				horizontal={openSnack.horizontal}
				open={openSnack.open}
				handleCloseSnack={handleCloseSnack}
				message={message}
				severity={severity}
      />
    </Box>
  );
};

export default SmartLockActions;
